import react from "react"
import reactDOM from "react-dom/client"
import App from "./App"
import "./index.css"
const root =reactDOM.createRoot(document.getElementById('root'))


root.render(<App/>)